import { reject, propEq } from 'ramda';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { LOG_OUT_EVENT } from '@app/data-services/session.service';
import * as i0 from "@angular/core";
import * as i1 from "../modules/member-state/services/debt.service";
const DEBT_KEYS = 'IS:SELECTED_DEBTS';
export class PaymentService {
    constructor(debtService) {
        this.debtService = debtService;
        this._paymentList$ = new BehaviorSubject(sessionStorage.getItem(DEBT_KEYS) ? JSON.parse(sessionStorage.getItem(DEBT_KEYS)) : []);
        this.paymentList$ = this._paymentList$.asObservable().pipe(tap((payDebts) => {
            sessionStorage.setItem(DEBT_KEYS, JSON.stringify(payDebts));
        }), shareReplay(1));
        this.commission$ = combineLatest([
            this.paymentList$,
            this.debtService.getCommission(),
        ]).pipe(map(([payDebts, commissionResponse]) => {
            if (!commissionResponse) {
                return null;
            }
            const total = payDebts.reduce((prev, debt) => prev + debt.amount, 0);
            const commissionAmount = (commissionResponse.value / 100) * total;
            const commission = {
                percentage: commissionResponse.value,
                description: commissionResponse.description,
                debt: {
                    serviceId: commissionResponse.service_id,
                    description: commissionResponse.name,
                    transactionId: commissionResponse.service_id,
                    amount: commissionAmount,
                },
            };
            return {
                commission,
                totalWithCommission: total + commissionAmount,
            };
        }), shareReplay(1));
        window.addEventListener(LOG_OUT_EVENT, () => {
            this._paymentList$.next([]);
            sessionStorage.removeItem(DEBT_KEYS);
        });
    }
    revalidateDebts() {
        return this.debtService.getDebts().pipe(map((debts) => {
            const validatedList = this._paymentList$.value.filter((paymentDebt) => debts.some((debt) => debt.id === paymentDebt.id));
            this._paymentList$.next(validatedList);
            return debts;
        }));
    }
    addItem(debtItem) {
        if (this._paymentList$.value.some((debt) => debt.id === debtItem.id))
            return;
        this._paymentList$.next([...this._paymentList$.value, debtItem]);
    }
    removeItem(item) {
        this._paymentList$.next(reject(propEq('id', item.id), this._paymentList$.value));
    }
    selectAll(items) {
        this._paymentList$.next([...items]);
    }
    removeAllItems() {
        this._paymentList$.next([]);
    }
}
PaymentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PaymentService_Factory() { return new PaymentService(i0.ɵɵinject(i1.DebtService)); }, token: PaymentService, providedIn: "root" });
